import { ProductCardSkeleton } from '@/feature/product/components/product-card/ProductCardSkeleton.client'
import { PRODUCTS_DISPLAYED_PER_PAGE } from '../../services/productList.constant'

export function ProductListSkeleton(): React.ReactElement {
  return (
    <div className="product-list-grid gap-2">
      {Array.from({ length: PRODUCTS_DISPLAYED_PER_PAGE }, (_, index) => (
        <ProductCardSkeleton key={index} />
      ))}
    </div>
  )
}
